import React from 'react';
import { ChatToggleButton, ChatWindow } from './components';
import { useChatSupport } from './hooks/useChatSupport';
import './ChatSupport.css';

const ChatSupport = () => {
  const {
    // State
    isOpen,
    isMinimized,
    isUserInfoSubmitted,
    currentSession,
    isInitializing,
    showScrollToBottom,
    isSubmittingMessage,
    messages,
    unreadCount,
    hasNewMessages,
    isTyping,
    connectionState,

    // User info
    isLoggedIn,
    loggedInUserName,
    loggedInUserEmail,

    // Form methods
    userInfoMethods,
    messageMethods,

    // Mutations
    initializeChatSessionMutation,
    sendMessageMutation,

    // Handlers
    handleToggleChat,
    handleMinimize,
    handleUserInfoSubmit,
    handleStartChatForLoggedInUser,
    handleSendMessage,
    handleCloseChat,
    handleScroll,
    scrollToBottom,
    handleKeyPress,
  } = useChatSupport();

  return (
    <>
      <ChatToggleButton
        isOpen={isOpen}
        unreadCount={unreadCount}
        hasNewMessages={hasNewMessages}
        onToggle={handleToggleChat}
      />

      <ChatWindow
        isOpen={isOpen}
        isMinimized={isMinimized}
        isInitializing={isInitializing}
        isUserInfoSubmitted={isUserInfoSubmitted}
        currentSession={currentSession}
        messages={messages}
        isTyping={isTyping}
        showScrollToBottom={showScrollToBottom}
        isSubmittingMessage={isSubmittingMessage}
        connectionState={connectionState}
        isLoggedIn={isLoggedIn}
        loggedInUserName={loggedInUserName}
        loggedInUserEmail={loggedInUserEmail}
        userInfoMethods={userInfoMethods}
        messageMethods={messageMethods}
        initializeChatSessionMutation={initializeChatSessionMutation}
        sendMessageMutation={sendMessageMutation}
        onMinimize={handleMinimize}
        onClose={handleCloseChat}
        onUserInfoSubmit={handleUserInfoSubmit}
        onStartChatForLoggedInUser={handleStartChatForLoggedInUser}
        onSendMessage={handleSendMessage}
        onKeyPress={handleKeyPress}
        onScroll={handleScroll}
        onScrollToBottom={scrollToBottom}
      />
    </>
  );
};

export default ChatSupport;
